import { isDevEnv } from '../../../helpers';
import { AnyFunction } from '../../language/AnyFunction';
import { PropertyKey } from '../../language/PropertyKey';
import DebugLogger from '../DebugLogger';

import { getLogger } from './InjectDebugLogger';
import { getLogFormats } from './LogFormat';
import { getResultFormat } from './ResultFormat';

const logResult = (
  log: DebugLogger,
  method: string,
  format: string,
  result: any
) => {
  let formatSpecifier = '%O';

  if (formatSpecifier.startsWith('%')) {
    formatSpecifier = format;
  }

  log(`%s %cresult: ${formatSpecifier}`, method, 'color: green', result);

  if (format === 'table' && isDevEnv()) {
    // eslint-disable-next-line no-console
    console.table(result);
  }
};

const logError = (log: DebugLogger, method: string, error: Error) =>
  log(
    '%s %cerror: [%s] %s',
    method,
    'color: red',
    (error as any).code || '-',
    error.message
  );

export const LogMethod = (
  target: any,
  property: PropertyKey,
  descriptor: TypedPropertyDescriptor<AnyFunction>
) => {
  const method = descriptor.value;

  if (!method) {
    return;
  }

  descriptor.value = function (...args: any[]) {
    const logger = getLogger(target.constructor);
    const formats = getLogFormats(target, property);
    const resultFormat = getResultFormat(target, property);

    const argFormats: string[] = [];
    const argValues: any[] = [];

    for (let index = 0; index < args.length; index++) {
      const format = formats.get(index);

      if (format) {
        argFormats.push(format);
        argValues.push(args[index]);
      }
    }

    const formatString = `%s(${argFormats.join(', ')})`;

    logger(formatString, method.name, ...argValues);

    const result = method.apply(this, args);

    if (result instanceof Promise) {
      return result
        .then(value => {
          logResult(logger, method.name, resultFormat, value);
          return value;
        })
        .catch(error => {
          logError(logger, method.name, error);
          throw error;
        });
    }

    logResult(logger, method.name, resultFormat, result);

    return result;
  };
};
